export default __webpack_public_path__ + "static/media/chat_location_2.77aeee0c.svg";